// Reads the stored JWT and checks its expiry locally, so a 403 can be
// distinguished as "expired session" instead of "forbidden".
function read_token() {
    const raw = localStorage.getItem('zmk_token')
    if (!raw) return null
    try {
        const value = JSON.parse(raw).value
        return value ? value.replace(/^Bearer\s+/i, '') : null
    } catch (e) {
        return null
    }
}

function base64url_decode(str) {
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    return atob(padded)
}

export function is_jwt_expired(token) {
    if (!token) return true
    const parts = token.split('.')
    if (parts.length < 2) return true
    try {
        const payload = JSON.parse(base64url_decode(parts[1]))
        return typeof payload.exp === 'number' && payload.exp * 1000 < Date.now()
    } catch (e) {
        return true
    }
}

export function is_token_expired() {
    return is_jwt_expired(read_token())
}
